/* eslint-disable */
import { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Select,
  MenuItem,
  OutlinedInput,
  InputLabel,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Message, IconButton, Row } from '@livechat/ui-kit';
import { PropTypes } from 'prop-types';
import happy from '../images/1Black.svg';
import happyActive from '../images/1Orange.svg';
import neutral from '../images/3Black.svg';
import neutralActive from '../images/3Orange.svg';
import sad from '../images/4Black.svg';
import sadActive from '../images/4Orange.svg';
import {
  BACK_TO_CHAT_ENG,
  BACK_TO_CHAT_ESP,
  SUBMIT_ENG,
  SUBMIT_ESP,
  ENTER_EMAIL_ADDRESS,
  ENTER_EMAIL_ADDRESS_ESP,
  ERROR_MESSAGE_TRANSCRIPT_ENG,
  ERROR_MESSAGE_TRANSCRIPT_ESP,
  FEEDBACK_WILL_HELP_ENG,
  FEEDBACK_WILL_HELP_ESP,
  SEND_CHAT_TRANSCRIPT_ENG,
  SEND_CHAT_TRANSCRIPT_ESP,
  RATE_YOUR_EXPERIENCE_ENG,
  RATE_YOUR_EXPERIENCE_ESP,
  ANYTHING_YOU_WANT_TO_SHARE_ENG,
  ANYTHING_YOU_WANT_TO_SHARE_ESP,
  MANDATORY_FIELD,
  INVALID_FORMAT,
  SATISFIED_FEEDBACK_MSG_ENG,
  SATISFIED_FEEDBACK_MSG_ESP,
  UNSATISFIED_FEEDBACK_MSG_ENG,
  UNSATISFIED_FEEDBACK_MSG_ESP,
  ADD_NEW_PHONE_NUMBER,
} from '../../../Constants';
import { WrapupStyles } from './WrapupStyles';
import { CustomTextArea } from '../utils/CustomTextArea';
import { CommonInput } from '../utils/CommonInput';
import commonSelectStyles from '../utils/CommonSelect.module.css';
import { submitFeedback } from '../../../app/CommonFunction';
import feedbackStyles from './Feedback.module.css';
import Done from '../images/Done.svg';
import AlertTriangleYellow from '../images/AlertTriangleYellow.svg';
import { CustomSelect } from '../utils/CustomSelect';
import selectStyles from '../utils/CustomSelect.module.css';
import Spinner from '../spinner/Spinner';

const useCommonStyles = WrapupStyles();

const StepTwo = (props) => {
  const {
    continueChat,
    endChat,
    sendToLex,
    englishBot,
    wrapEmail,
    isLogin,
    deliveryMedium,
    emailList,
    phoneList,
    customerGuid,
    customerEmail,
    customerName,
    customerPhone,
    size,
    token,
    getAccessToken,
    sessionID,
  } = props;
  const WrapupCssStyles = useCommonStyles();
  const [modalMessage, setModalMessage] = useState('Thank you!');
  const [happyImage, setHappyImage] = useState(happy);
  const [neutralImage, setNeutralImage] = useState(neutral);
  const [sadImage, setSadImage] = useState(sad);
  const [happyPress, setHappyPress] = useState(false);
  const [neutralPress, setNeutralPress] = useState(false);
  const [sadPress, setSadPress] = useState(false);
  const [feedbackReaction, setFeedbackReaction] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [checked, setChecked] = useState(false);
  const [emailValid, setEmailValid] = useState(wrapEmail !== '');
  const [emailValue, setEmailValue] = useState(wrapEmail !== '' ? wrapEmail : '');
  const defaultContent = englishBot ? FEEDBACK_WILL_HELP_ENG : FEEDBACK_WILL_HELP_ESP;
  const defaultEndChat = englishBot ? SUBMIT_ENG : SUBMIT_ESP;
  const defaultContinueChat = englishBot ? BACK_TO_CHAT_ENG : BACK_TO_CHAT_ESP;
  const emailInputPlaceholder = englishBot ? ENTER_EMAIL_ADDRESS : ENTER_EMAIL_ADDRESS_ESP;
  const checkboxLabel = englishBot ? SEND_CHAT_TRANSCRIPT_ENG : SEND_CHAT_TRANSCRIPT_ESP;
  const errorMessage = englishBot ? ERROR_MESSAGE_TRANSCRIPT_ENG : ERROR_MESSAGE_TRANSCRIPT_ESP;
  const [wantToSay, setWantToSay] = useState('');
  const [wantToSayError, setWantToSayError] = useState('');
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [showFeedbackSuccessCard, setShowFeedbackSuccessCard] = useState(false);
  const [emailArr, setEmailArr] = useState([]);
  const [emailArrD, setEmailArrD] = useState([]);
  const [emailData, setEmailData] = useState({ emailSelect: '', emailId: '' });
  const [emailDataError, setEmailDataError] = useState({ emailSelect: '', emailId: '' });
  const [phoneArr, setPhoneArr] = useState([]);
  const [selectedPhone, setSelectedPhone] = useState('');
  const [selectedPhoneError, setSelectedPhoneError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    const phones = phoneList?.map((item) => {
      return item.phone;
    });
    setPhoneArr(phones);
  }, [phoneList]);

  useEffect(() => {
    setModalContent();
    if (feedbackReaction !== '' && wantToSayError === '' && happyPress) {
      setDisabled(false);
    } /* for negative feedback logged out state */ else if (
      !isLogin &&
      feedbackReaction !== '' &&
      wantToSay !== '' &&
      wantToSayError === '' &&
      // name !== '' &&
      // nameError === '' &&
      // email !== '' &&
      // emailError === '' &&
      // phone !== '' &&
      // phoneError === '' &&
      (neutralPress || sadPress)
    ) {
      setDisabled(false);
    } /* for negative feedback logged in state depending on deliveryMedium */ else if (
      isLogin &&
      deliveryMedium === 'email' &&
      feedbackReaction !== '' &&
      wantToSay !== '' &&
      wantToSayError === '' &&
      selectedPhone !== '' &&
      selectedPhoneError === '' &&
      ((selectedPhone !== '' &&
        selectedPhone !== ADD_NEW_PHONE_NUMBER &&
        selectedPhoneError === '') ||
        (selectedPhone === ADD_NEW_PHONE_NUMBER && phone !== '' && phoneError === '')) &&
      (neutralPress || sadPress)
    ) {
      setDisabled(false);
    } else if (
      isLogin &&
      (deliveryMedium === 'phoneCall' || deliveryMedium === 'textMessage') &&
      feedbackReaction !== '' &&
      wantToSay !== '' &&
      wantToSayError === '' &&
      ((emailData.emailSelect !== '' &&
        emailData.emailSelect !== 'Add Email' &&
        emailDataError.emailSelect === '') ||
        (emailData.emailSelect === 'Add Email' &&
          emailData.emailId !== '' &&
          emailDataError.emailId === '')) &&
      (neutralPress || sadPress)
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [
    emailData,
    emailDataError,
    feedbackReaction,
    isLogin,
    wantToSay,
    happyPress,
    neutralPress,
    sadPress,
    wantToSayError,
    name,
    email,
    phone,
    selectedPhone,
    emailError,
    nameError,
    phoneError,
    deliveryMedium,
    selectedPhoneError,
  ]);

  const setModalContent = () => {
    if (sadPress || neutralPress) {
      setModalMessage(englishBot ? UNSATISFIED_FEEDBACK_MSG_ENG : UNSATISFIED_FEEDBACK_MSG_ESP);
    } else {
      setModalMessage(englishBot ? SATISFIED_FEEDBACK_MSG_ENG : SATISFIED_FEEDBACK_MSG_ESP);
    }
  };

  useEffect(() => {
    if (feedbackReaction === 'happy') {
      setName('');
      setNameError('');
      setEmail('');
      setEmailError('');
      setPhone('');
      setPhoneError('');
      setSelectedPhone('');
      setSelectedPhoneError('');
      setEmailData({ emailSelect: '', emailId: '' });
      setEmailDataError({ emailSelect: '', emailId: '' });
    }
  }, [feedbackReaction]);

  let emailAdds = [];

  useEffect(() => {
    const emails = emailList?.map((item) => {
      return item.EmailAddr;
    });

    emails?.forEach((item) => {
      emailAdds.push({
        masked: item,
        unmasked: item,
      });
    });

    setEmailArr(emailAdds);
    setEmailArrD(emailAdds);
  }, [emailList]);

  useEffect(() => {
    setEmailData({ ...emailData, emailId: '' });
    if (emailData.emailSelect === 'Add Email') {
      if (emailData.emailId) {
        setEmailData({ ...emailData, unmaskedEmail: '' });
      } else {
        setEmailData({ ...emailData, emailId: '', unmaskedEmail: '' });
      }
    }
    setEmailDataError({ ...emailDataError, emailId: '' });
  }, [emailData.emailSelect]);

  const checkboxClickHandler = () => {
    setChecked(!checked);
  };

  const handleIconsStyleChange = (value) => {
    switch (value) {
      case 'happy':
        setHappyImage(happyActive);
        setNeutralImage(neutral);
        setSadImage(sad);
        break;
      case 'neutral':
        setHappyImage(happy);
        setNeutralImage(neutralActive);
        setSadImage(sad);
        break;
      case 'unhappy':
        setHappyImage(happy);
        setNeutralImage(neutral);
        setSadImage(sadActive);
        break;
      default:
        break;
    }
  };

  const handleHoverOn = (value) => {
    handleIconsStyleChange(value);
  };

  const handleHoverOut = (value) => {
    if (feedbackReaction === '') {
      setHappyImage(happy);
      setNeutralImage(neutral);
      setSadImage(sad);
    } else {
      handleIconsStyleChange(feedbackReaction);
    }
  };

  const handleRating = (value) => {
    setFeedbackReaction(value);
    switch (value) {
      case 'happy':
        setHappyImage(happyActive);
        setNeutralImage(neutral);
        setSadImage(sad);
        setHappyPress(true);
        setNeutralPress(false);
        setSadPress(false);
        setDisabled(true);
        break;
      case 'neutral':
        setHappyImage(happy);
        setNeutralImage(neutralActive);
        setSadImage(sad);
        setHappyPress(false);
        setNeutralPress(true);
        setSadPress(false);
        break;
      case 'unhappy':
        setHappyImage(happy);
        setNeutralImage(neutral);
        setSadImage(sadActive);
        setHappyPress(false);
        setNeutralPress(false);
        setSadPress(true);
        break;
      default:
        break;
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (e.target.value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
      const emailFirstSplit = e.target.value.split('@');
      if (
        emailFirstSplit[0].charAt(0) !== '-' &&
        emailFirstSplit[0].charAt(emailFirstSplit[0].length - 1) !== '.' &&
        emailFirstSplit[0].charAt(0) !== '.' &&
        emailFirstSplit[0].charAt(emailFirstSplit[0].length - 1) !== '-' &&
        !e.target.value.match(/[.\-_]{2,}/)
      ) {
        setEmailError('');
      } else {
        setEmailError(englishBot ? INVALID_FORMAT : '* Formato inválido');
      }
    } else if (e.target.value === '') {
      setEmailError('');
    } else if (e.target.value !== '') {
      setEmailError(englishBot ? INVALID_FORMAT : '* Formato inválido');
    }
  };

  const handlePhoneChange = (e) => {
    if (e.target.name === 'phone') {
      // phone number input for not logged in
      const phoneRegex = /^\d+$/;
      if (e.target.value !== '') {
        if (e.target.value.match(phoneRegex)) {
          if (e.target.value.length === 10) {
            setPhone(e.target.value);
            setPhoneError('');
          } else if (e.target.value.length < 10) {
            setPhone(e.target.value);
            setPhoneError(englishBot ? INVALID_FORMAT : '* Formato inválido');
          }
        }
      } else {
        setPhone(e.target.value);
        setPhoneError('');
      }
    } else {
      // phone number dropdown
      if (e.target.value !== '') {
        setSelectedPhone(e.target.value);
        setSelectedPhoneError('');
      } else {
        setSelectedPhone(e.target.value);
        setSelectedPhoneError(englishBot ? MANDATORY_FIELD : '* Campo Requerido');
      }
    }
  };

  const handleNameChange = (e) => {
    if (e.target.value) {
      if (e.target.value.match(/^[A-Za-z\s]*$/)) {
        setName(e.target.value);
        setNameError('');
      }
    } else {
      setName(e.target.value);
      setNameError('');
    }
  };

  const addEmailChange = (e) => {
    if (e.target.value === 'Add Email') {
      setEmailData({ ...emailData, unmaskedEmail: '', [e.target.name]: e.target.value });
      setEmailDataError({
        ...emailDataError,
        [e.target.name]: '',
      });
    } else if (e.target.value) {
      const result2 = emailArrD.filter((itemc) => {
        if (itemc.masked === e.target.value) {
          return itemc;
        }
      });
      setEmailData({
        ...emailData,
        [e.target.name]: e.target.value,
        unmaskedEmail: result2[0].unmasked,
      });
      setEmailDataError({
        ...emailDataError,
        [e.target.name]: '',
      });
    } else if (e.target.value === '') {
      setEmailData({ ...emailData, unmaskedEmail: '', [e.target.name]: '' });
      setEmailDataError({
        ...emailDataError,
        [e.target.name]: englishBot ? '* Mandatory Field' : '* Campo Requerido',
      });
    }
  };

  const handleChangeEmail = (e) => {
    if (e.target.name === 'emailSelect') {
      addEmailChange(e);
    } else if (e.target.name === 'emailId') {
      setEmailData({ ...emailData, [e.target.name]: e.target.value });
      if (e.target.value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
        const emailFirstPart = e.target.value.split('@');
        if (
          emailFirstPart[0].charAt(0) !== '-' &&
          emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '.' &&
          emailFirstPart[0].charAt(0) !== '.' &&
          emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '-' &&
          !e.target.value.match(/[.\-_]{2,}/)
        ) {
          setEmailDataError({ ...emailDataError, emailId: '' });
        } else {
          setEmailDataError({
            ...emailDataError,
            emailId: englishBot ? '* Invalid Format' : '* Formato inválido',
          });
        }
      } else if (e.target.value === '') {
        setEmailDataError({
          ...emailDataError,
          emailId: englishBot ? '* Mandatory Field' : '* Campo Requerido',
        });
      } else {
        setEmailDataError({
          ...emailDataError,
          emailId: englishBot ? '* Invalid Format' : '* Formato inválido',
        });
      }
    }
  };

  const handleCommentChange = (e) => {
    if (e.target.value) {
      setWantToSay(e.target.value.trimStart());
      setWantToSayError('');
    } else if (e.target.value === '') {
      setWantToSay(e.target.value);
      if (feedbackReaction !== 'happy') {
        setWantToSayError(englishBot ? MANDATORY_FIELD : '* Campo Requerido');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const generateKey = () => {
      return Array.from(Array(32), () => Math.floor(Math.random() * 36).toString(36)).join('');
    };
    const UUID = generateKey();
    let feedbackData = {
      uuid: UUID,
      customerGuid,
      language: englishBot ? 'ENG' : 'ESP',
      customerEmail,
      customerName,
      customerPhone,
      feedbackInput: wantToSay,
      feedbackRating: feedbackReaction,
      feedbackSource: 'SSP',
      isLogin,
      token,
      sessionID,
    };
    if (isLogin && deliveryMedium === 'email') {
      feedbackData = {
        ...feedbackData,
        customerPhone: selectedPhone === ADD_NEW_PHONE_NUMBER ? phone : selectedPhone,
      };
    } else if (isLogin && (deliveryMedium === 'phoneCall' || deliveryMedium === 'textMessage')) {
      feedbackData = {
        ...feedbackData,
        customerEmail:
          emailData.emailSelect === 'Add Email' ? emailData.emailId : emailData.emailSelect,
      };
    } else if (!isLogin) {
      feedbackData = {
        ...feedbackData,
        customerName: name,
        customerEmail: email,
        customerPhone: phone,
      };
    }
    try {
      const response = await submitFeedback(feedbackData);
      if (response && response.status === 200) {
        setShowFeedbackSuccessCard(true);
      }
    } catch (err) {
      if (
        err.message === 'Request failed with status code 403' ||
        err.message === 'Request failed with status code 401'
      ) {
        getAccessToken(true, 'feedback', feedbackData);
      }
    }
    setIsSubmitting(false);
  };

  const emailHandler = (e) => {
    if (
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i.test(
        e.target.value
      )
    ) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
    }
    setEmailValue(e.target.value);
  };
  const emailErrorMessageNoDisplay = {
    display: 'none',
  };
  const eemailErrorMessageDisplay = {
    margin: '0 auto',
    color: '#DF0000',
    marginTop: '5px',
  };
  const emailOpacity = {
    opacity: '0.5',
    pointerEvents: 'none',
  };
  const emailOpacityFull = {
    opacity: '1',
  };
  useEffect(() => {
    const wrapupBtns = document.getElementsByClassName('wrapupTwoBtn');
    if (wrapupBtns && document.getElementsByClassName('wrapupTwoBtn').length > 0) {
      wrapupBtns[0].firstChild.focus();
    }
  }, []);
  const endChatHandler = () => {
    endChat();
  };
  return (
    <Message
      className="wrapup-containerTwo"
      style={{
        textAlign: 'center',
        position: 'relative',
      }}
    >
      {showFeedbackSuccessCard ? (
        <div className={WrapupCssStyles.text_design}>
          <Box className={feedbackStyles.feedbackSuccessContainer}>
            <Box style={{ textAlign: 'center', marginBottom: '20px' }}>
              <img
                alt="success"
                src={feedbackReaction === 'happy' ? Done : AlertTriangleYellow}
                width="93"
                height="93"
              />
            </Box>
            <Typography className={feedbackStyles.feedbackMessageText}>{modalMessage}</Typography>
            <Grid container xs={12} spacing={0} className={feedbackStyles.okButtonBox}>
              <button
                type="button"
                className={feedbackStyles.btnOk}
                data-testid="ok_testId"
                onClick={endChatHandler}
              >
                {englishBot ? 'Ok' : 'De acuerdo'}
              </button>
            </Grid>
          </Box>
        </div>
      ) : (
        <div className={WrapupCssStyles.text_design}>
          <div className="endchatHeading" style={{ padding: '20px 40px 10px' }}>
            {defaultContent}
          </div>
          <div className={WrapupCssStyles.rateExperience}>
            {englishBot ? RATE_YOUR_EXPERIENCE_ENG : RATE_YOUR_EXPERIENCE_ESP}
          </div>
          <div className={WrapupCssStyles.text_position}>
            <div className={WrapupCssStyles.agentWrapupContainer}>
              <div className={WrapupCssStyles.wrapupTwoBtn}>
                <div
                  className={WrapupCssStyles.iconPadding}
                  onClick={() => handleRating('unhappy')}
                  onKeyDown={() => handleRating('unhappy')}
                  onMouseEnter={() => handleHoverOn('unhappy')}
                  onMouseLeave={() => handleHoverOut('unhappy')}
                  data-testid="handleRating_sad_testid"
                  tabIndex="0"
                  aria-label="sad emoji"
                  aria-pressed={sadPress}
                >
                  <img alt="sad" className={WrapupCssStyles.smileyImg} src={sadImage} />
                </div>
              </div>
              <div className={WrapupCssStyles.wrapupTwoBtn}>
                <div
                  className={WrapupCssStyles.iconPadding}
                  onClick={() => handleRating('neutral')}
                  onKeyDown={() => handleRating('neutral')}
                  onMouseEnter={() => handleHoverOn('neutral')}
                  onMouseLeave={() => handleHoverOut('neutral')}
                  data-testid="handleRating_neutral_testid"
                  tabIndex="0"
                  aria-label="neutral emoji"
                  aria-pressed={neutralPress}
                >
                  <img alt="neutral" className={WrapupCssStyles.smileyImg} src={neutralImage} />
                </div>
              </div>
              <div className={WrapupCssStyles.wrapupTwoBtn}>
                <div
                  className={WrapupCssStyles.iconPadding}
                  onClick={() => handleRating('happy')}
                  onKeyDown={() => handleRating('happy')}
                  onMouseEnter={() => handleHoverOn('happy')}
                  onMouseLeave={() => handleHoverOut('happy')}
                  data-testid="handleRating_excited_testid"
                  tabIndex="0"
                  aria-label="happy emoji"
                  aria-pressed={happyPress}
                >
                  <img alt="happy" className={WrapupCssStyles.smileyImg} src={happyImage} />
                </div>
              </div>
            </div>
          </div>
          {feedbackReaction && (
            <div id="commentBox" className={WrapupCssStyles.textFieldsBottomMargin}>
              <CustomTextArea
                required={!happyPress}
                multiLine
                inputLabelClassName={WrapupCssStyles.label_title_Area}
                label={englishBot ? ANYTHING_YOU_WANT_TO_SHARE_ENG : ANYTHING_YOU_WANT_TO_SHARE_ESP}
                fullWidth
                noColon
                maxLength={160}
                id="comment"
                name="comment"
                dataTestId="commentTestId"
                isStar
                handleChange={handleCommentChange}
                placeholder={englishBot ? 'Provide your comments.' : 'Coméntanos aquí.'}
                inputProps={{
                  'data-testid': 'wantToSayTestId',
                  maxLength: 160,
                }}
                value={wantToSay}
                error={wantToSayError}
              />
            </div>
          )}
          {(feedbackReaction === 'neutral' || feedbackReaction === 'unhappy') && (
            <Grid container spacing={2} style={{ padding: '10px' }}>
              {!isLogin && (
                <>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Box>
                      <CommonInput
                        fullWidth
                        inputLabelAriaLabel="name"
                        label={englishBot ? 'Name' : 'Nombre'}
                        id="name"
                        name="name"
                        dataTestId="name_testid"
                        handleChange={handleNameChange}
                        value={name}
                        asterisk={false}
                        error={nameError}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6}>
                    <Box>
                      <CommonInput
                        fullWidth
                        inputLabelAriaLabel="phone"
                        label={englishBot ? 'Phone Number' : 'Número de teléfono'}
                        id="phone"
                        name="phone"
                        dataTestId="phone_testid"
                        handleChange={handlePhoneChange}
                        value={phone}
                        asterisk={false}
                        error={phoneError}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6}>
                    <Box>
                      <CommonInput
                        fullWidth
                        inputLabelAriaLabel="email"
                        label={englishBot ? 'Email' : 'Correo electrónico'}
                        id="email"
                        name="email"
                        dataTestId="email_testid"
                        handleChange={handleEmailChange}
                        value={email}
                        asterisk={false}
                        error={emailError}
                      />
                    </Box>
                  </Grid>
                </>
              )}
              {isLogin && (deliveryMedium === 'phoneCall' || deliveryMedium === 'textMessage') && (
                <>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Box display={'flex'} flexDirection={'column'} alignItems={'flex-start'}>
                      <Box sx={{ display: 'flex' }}>
                        <InputLabel className={feedbackStyles.optionTextPayment}>
                          {englishBot ? 'Email:' : 'Correo electrónico:'}
                        </InputLabel>
                      </Box>
                      <Select
                        labelId="EmailList-label"
                        id="emailSelect"
                        name="emailSelect"
                        role="listbox"
                        variant="outlined"
                        fullWidth
                        onChange={handleChangeEmail}
                        displayEmpty
                        value={emailData.emailSelect}
                        inputProps={{ 'data-testid': 'emailSelect_testId' }}
                        IconComponent={KeyboardArrowDownIcon}
                        style={{
                          icon: commonSelectStyles.select_icon,
                          textAlign: 'left',
                        }}
                        className={selectStyles.select_inputs}
                        classes={{ icon: commonSelectStyles.iconSelect }}
                      >
                        <MenuItem role="option" value="">
                          {englishBot ? 'Email' : 'Correo electrónico'}
                        </MenuItem>
                        {emailArr?.map((item, i) => {
                          if (item != '') {
                            return (
                              <MenuItem role="option" key={item.masked} value={item.masked}>
                                {item.masked}
                              </MenuItem>
                            );
                          }
                        })}
                        <MenuItem role="option" value="Add Email">
                          {englishBot ? 'Add new email' : 'Añadir nuevo correo electrónico'}
                        </MenuItem>
                      </Select>
                      {emailDataError.emailSelect && (
                        <Box className="errorMsg" role="alert">
                          {emailDataError.emailSelect}
                        </Box>
                      )}
                    </Box>
                  </Grid>
                  {emailData.emailSelect === 'Add Email' && (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Box textAlign="left">
                        <Typography className={feedbackStyles.optionTextPayment}>
                          {englishBot
                            ? 'Please enter your new email:'
                            : 'Por favor ingresa tu nuevo correo electrónico:'}
                        </Typography>
                        <OutlinedInput
                          id="emailId"
                          name="emailId"
                          className={`${feedbackStyles.outlined_inputs} ${
                            emailDataError.emailId && feedbackStyles.outlined_inputs_error
                          } `}
                          autoComplete="off"
                          onChange={handleChangeEmail}
                          inputProps={{ 'data-testid': 'emailInput_testId' }}
                          fullWidth
                          value={emailData.emailId}
                        />
                        {emailDataError.emailId && (
                          <Box className="errorMsg" role="alert">
                            {emailDataError.emailId}
                          </Box>
                        )}
                      </Box>
                    </Grid>
                  )}
                </>
              )}
              {isLogin && deliveryMedium === 'email' && (
                <>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Box>
                      <CustomSelect
                        label={englishBot ? `Phone Number` : 'Número de teléfono'}
                        fullWidth
                        id="mobileNumber"
                        dataTestId="phoneSelect_testId"
                        options={phoneArr}
                        handleChange={handlePhoneChange}
                        value={selectedPhone}
                        error={selectedPhoneError}
                        screen="otp"
                        phoneLabel="true"
                        colon
                        addPhoneNumberItem={true}
                        englishBot={englishBot}
                      />
                    </Box>
                  </Grid>
                  {selectedPhone === 'Add new phone number' && (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Box>
                        <CommonInput
                          fullWidth
                          inputLabelAriaLabel="phone"
                          label={
                            englishBot
                              ? 'Please enter your new number:'
                              : 'Por favor ingrese su nuevo número:'
                          }
                          id="phone"
                          name="phone"
                          dataTestId="phone_testid"
                          handleChange={handlePhoneChange}
                          value={phone}
                          asterisk
                          error={phoneError}
                        />
                      </Box>
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          )}
          <div className="fixedBtnContainer">
            <IconButton
              className="secondaryBtn"
              onClick={continueChat}
              disabled={isSubmitting}
              tabIndex="102"
              data-testid="continuechat_id"
            >
              {defaultContinueChat}
            </IconButton>
            <IconButton
              className="primaryBtn"
              disabled={disabled || isSubmitting}
              onClick={handleSubmit}
              data-testid="endbtn_testid"
              tabIndex="102"
            >
              {defaultEndChat}
            </IconButton>
          </div>
        </div>
      )}
      {/* Spinner overlay */}
      {isSubmitting && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: '#fff',
            transition: 'backgroung 0.3s ease-in-out',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Spinner
            size={20}
            englishBot={englishBot}
            label={englishBot ? 'Submitting...' : 'Enviando...'}
          />
        </div>
      )}
    </Message>
  );
};

StepTwo.propTypes = {
  continueChat: PropTypes.func,
  endChat: PropTypes.func,
  englishBot: PropTypes.bool,
  wrapEmail: PropTypes.bool,
  sendToLex: PropTypes.bool,
  isLogin: PropTypes.bool,
  deliveryMedium: PropTypes.string,
  phoneList: PropTypes.shape([]),
  emailList: PropTypes.shape([]),
  customerGuid: PropTypes.string,
  customerEmail: PropTypes.string,
  customerName: PropTypes.string,
  customerPhone: PropTypes.string,
};

export default StepTwo;
